export interface ReportData {
    'id': number;
    '@id': string;
    'form': string;
    'elements': ReportElementData[];
}
export class Report {
    id: number;
    uri: string;
    form: string;
    elements: ReportElement[];

    constructor(data: ReportData) {
        this.id = data.id;
        this.uri = data['@id'];
        this.form = data.form;
        this.elements = data.elements.map(
            (d: ReportElementData) => new ReportElement({ ...d, ...{ report: data['@id'], form: data.form } }),
        );
    }
}

export interface ReportElementData {
    'id': number | any;
    '@id': string;
    'form': string;
    'report': string;
    'title': string;
    'type': ReportElementTypeData;
    'weight': number;
    'params': ReportElementParamsData;
    'visibilityRuleSet': string[];
}

export class ReportElement {
    id: number;
    uri: string;
    form: string;
    report: string;
    weight: number;
    type: ReportElementType;
    params: ReportElementParams;
    visibilityRuleSetRefs: string[];
    title: string = '';

    constructor(data: ReportElementData) {
        this.title = data.title;
        this.id = data.id;
        this.uri = data['@id'];
        this.form = data.form;
        this.report = data.report;
        this.weight = data.weight;
        this.type = new ReportElementType(data.type);
        this.params = new ReportElementParams(data.params);
        this.visibilityRuleSetRefs = data.visibilityRuleSet;
    }
}

export interface ReportElementTypeData {
    'id': number;
    '@id': string;
    'title': string;
    'component': string;
}

export class ReportElementType {
    id: number;
    uri: string;
    title: string;
    component: string;

    constructor(data: ReportElementTypeData) {
        this.id = data.id;
        this.uri = data['@id'];
        this.title = data.title;
        this.component = data.component;
    }
}

export interface ReportElementParamsData {
    body: string;
    text: string;
    label: string;
    description: string;
    color: string;
    url: string;
}

export class ReportElementParams {
    body: string;
    text: string;
    label: string;
    description: string;
    color: string;
    url: string;

    constructor(params: ReportElementParamsData) {
        this.body = params.body || '';
        this.text = params.text || '';
        this.label = params.label || '';
        this.description = params.description || '';
        this.color = params.color || '';
        this.url = params.url || '';
    }
}
